import { bindRumUser, getClientErrorHandler, initRum } from '@/utils/errors/clientErrorHandler';
import { useAuthStore } from '~/stores/auth';
import { useConfigStore } from '~/stores/config';

export default defineNuxtPlugin({
  name: 'errorHandler',
  dependsOn: [],
  setup: (nuxtApp) => {
    const { apiUrl, code } = useCurrentCluster();
    const configStore = useConfigStore();

    const config = useRuntimeConfig();
    const errorHandler = getClientErrorHandler(config);
    initRum(config, {
      apiUrl: apiUrl.value,
      clusterCode: code.value,
      suppressSessionReplay: configStore.suppressMarketingTechnologies,
    });
    nuxtApp.hook('app:created', () => nuxtApp.runWithContext(() => {
      const authStore = useAuthStore();
      bindRumUser(config, { getExternalId: () => authStore.user?.externalId ?? null });
    }));
    const { logError, logErrorMessage, logWarnMessage, logInfoMessage } = setupErrorHandling(errorHandler);
    return { provide: { logError, logErrorMessage, logWarnMessage, logInfoMessage } };
  },
});
